import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstPrb: [],
        prb: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getPrb(state) {
            return state.prb
        },
        getPrbfamilia(state) {
            return state.prb.prbfamilia
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, prb) {
            state.prb = prb
            if (prb)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.prb = null
        },
        setParamsDataTable(state, payload) {
            state.lstPrb = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setPrb(state, prb) {
            state.prb = prb
        },
        setLstPrb(state, lstPrb) {
            state.lstPrb = lstPrb
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, { prbfamilia }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Family/Find/${prbfamilia}`)
                .then(response => {
                    let prb = Utils.ValidateAxiosResponse(response.data);
                    commit("set", prb)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ dispatch, getters }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Products/Family/Insert", getters.getPrb)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setPrb", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async update({ commit, dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Products/Family/Update", getters.getPrb)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setPrb", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async delete({ dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/Family/Delete/${getters.getPrbfamilia}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/produto-familias")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, dispatch, getters }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Family/FindList`)
                .then(response => {
                    let lstPrb = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstPrb", lstPrb)
                    commit("setHasNext", lstPrb.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstPrb", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/Family/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstPrb", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
    }
}